import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a604c4c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AudioOutline = _resolveComponent("AudioOutline")

  return (_openBlock(), _createBlock("div", {
    class: "base-element-image",
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
      transform: `rotate(${_ctx.elementInfo.rotate}deg)`,
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _createVNode("div", {
        class: "element-content",
        style: {
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        }
      }, [
        _createVNode(_component_AudioOutline, { elementInfo: _ctx.elementInfo }, null, 8, ["elementInfo"]),
        _createVNode("div", {
          class: "image-content",
          style: { clipPath: _ctx.clipShape.style }
        }, [
          _createVNode("audio", {
            src: _ctx.elementInfo.src,
            style: {
              top: _ctx.imgPosition.top,
              left: _ctx.imgPosition.left,
              width: _ctx.imgPosition.width,
              height: _ctx.imgPosition.height,
              filter: _ctx.filter,
              'pointer-events': 'none'
            },
            class: "audioPPT",
            controls: "controls",
            controlslist: "nodownload",
            disablePictureInPicture: true,
            muted: ""
          }, null, 12, ["src"])
        ], 4)
      ], 4)
    ], 4)
  ], 4))
})